<template>
  <div>
    <p class="lead text-white mt-4 mb-5">Select filter to continue.</p>
    <ul>
      <li v-for="(item,id) in filteroptions" :key="id" :id="item.id" v-on:click='getInformation'>
        <img :src="item.image"  :data="item.value" />
        <p :data="item.value">{{item.value}}</p>
      </li>
    </ul>
    <div class="light"></div>
  </div>
</template>
<script>
export default {
  name: "filterSelect",
  components: {},
  data() {
    return {
      filtervalue: null,
      filteroptions:[
        {"id":"1", "value":"Our best seller","image":"/img/myimages/1.jpeg"},
        {"id":"2", "value":"Best visiting season","image":"/img/myimages/1.jpeg"},
        {"id":"3", "value":"With budget","image":"/img/myimages/1.jpeg"},
        {"id":"4", "value":"Visa for /visa on arrival","image":"/img/myimages/1.jpeg"},
        {"id":"5", "value":"Fly","image":"/img/myimages/1.jpeg"},
        {"id":"6", "value":"India special","image":"/img/myimages/1.jpeg"},
        {"id":"7", "value":"Solo travel","image":"/img/myimages/1.jpeg"},
        {"id":"8", "value":"honeymoon special","image":"/img/myimages/1.jpeg"},
      ]
    };
  },
  methods:{
    getInformation: function (event) {
      this.filtervalue=this.filteroptions(event.target.getAttribute('data'))
    }
  }
};
</script>
<style scoped>
ul {
  margin-top: -4%;
  margin-bottom: 4rem;
  cursor: pointer;
}
img {
  width: 180px;
}
li {
  text-align: center;
  display: inline-block;
  list-style: none;
  position: relative;
  border: solid 12px #fff;
  background: #fff;
  box-shadow: 0 0 15px 0px #555;
  transition: all 1s ease;
  -o-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -webkit-transition: all 1s ease;
  top: 50px;
  margin-bottom: 50px;
  cursor: pointer;
}

li:hover {
  top: 0px;
  opacity: 0.9;
}

li:nth-child(1) {
  transform: rotate(10deg);
}

li:nth-child(2) {
  transform: rotate(0deg);
}

li:nth-child(3) {
  transform: rotate(-10deg);
}

li:nth-child(4) {
  transform: rotate(20deg);
}
li:nth-child(5) {
  transform: rotate(10deg);
}

li:nth-child(6) {
  transform: rotate(0deg);
}

li:nth-child(7) {
  transform: rotate(-10deg);
}

li:nth-child(8) {
  transform: rotate(20deg);
}

ul > li > p {
  margin: -15px 0 0 0;
  font-size: 1em;
  font-weight: 800;
  color: blue;
}
.light {
  border-radius: 50%;
  position: absolute;
  left: 0;
  right: 0;
  width: 700px;
  height: 700px;
  background: #fff;
  filter: blur(100px);
  opacity: 0.3;
  pointer-events: none;
}
</style>
